/**
 * Author:hong.rong
 * Desc:工具类
 * Date:2022-09-15
 */

import memoize from 'lodash/memoize'

/**
 * @name: 获取字符串宽度
 * @author:  miroku
 * @description: 根据font-size 计算文字所占宽度
 * */

export const calcTextWidth = memoize(
  (text, fontSize, options: any = {}) => {
    const { fontFamily, fontWeight }: any = {
      fontFamily: 'Arial',
      fontWeight: 'normal',
      ...options,
    }
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    ctx.font = `${fontSize} ${fontFamily} ${fontWeight}`
    return ctx.measureText(text).width
  },
  (text, fontSize, options) => {
    const obj = { ...options, text, fontSize }
    return Object.keys(obj)
      .map(key => `${key}-${obj[key]}`)
      .join(',')
  },
)

/**
 * 文件类型
 */
export const fileMap = {
  0: 'iconqitawenjiangeshi', // 其他格式
  1: 'iconwenjianjia',
  2: 'iconTXT',
  3: 'iconPPT',
  4: 'iconshipin1',
  5: 'iconyinpin',
  6: 'iconExcel',
  7: 'iconrar',
  8: 'icontupianicon',
}
/**
 * 文件类型转数字
 * @param fileType
 * @param mime_type
 */
export const fileTypeToNumber = (fileType, mime_type) => {
  let num = 0
  if (fileType === 'dir') {
    num = 1
    return num
  }
  if (!mime_type) {
    return num
  }
  if (mime_type.includes('image/')) {
    num = 8
  } else if (mime_type.includes('text/')) {
    num = 2
  } else if (mime_type.includes('powerpoint')) {
    num = 3
  } else if (mime_type.includes('video/')) {
    num = 4
  } else if (mime_type.includes('audio/')) {
    num = 5
  } else if (mime_type.includes('.sheet')) {
    num = 6
  } else if (mime_type.includes('/zip')) {
    num = 7
  }
  return num
}

/**
 * 转换面包屑
 * @param breadList
 * @param node
 */
export const transformBread = (breadList: any[] = [], node: any = {}, allTxt = '') => {
  const newBreadList = []
  const stack = [...breadList]
  if (node && node.uuid && node.name) {
    stack.push(node)
  }
  while (stack.length) {
    const curNode: any = stack.pop()
    curNode.textWidth = calcTextWidth(curNode.name === '/' ? allTxt : curNode.name, 14) // 推出栈顶元素
    newBreadList.push(curNode)
  }
  return newBreadList.reverse()
}
